import { render, staticRenderFns } from "./AutoFights.vue?vue&type=template&id=51db13a8&"
import script from "./AutoFights.vue?vue&type=script&lang=js&"
export * from "./AutoFights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports